import React from 'react';
import { array, number } from 'prop-types';

import './wizardSteps.scss';

export default class KovWizardSteps extends React.Component {
  isDone(index) {
    return this.props.currentStep > index;
  }

  render() {
    return (
      <div className="kov-wizard-steps-shared-components">
        {this.props.steps.map((step, index) =>
          <div key={index} className="wizard-step">
            <div className="wizard-step-title">{step.title}</div>
            <div className="wizard-step-body" style={{height: this.props.height}}>
              <div className={`wizard-separator wizard-separator-left ${this.isDone(index) ? 'is-done' : ''}`}
                style={{margin: this.props.height/2-4 + 'px -1px'}}
              />
              { !step.icon &&
                <div className={`wizard-step-circle ${this.isDone(index) ? 'is-done' : 'is-not-done'}`}
                  style={{flex: this.props.height + 'px 0 0', fontSize: this.props.height/2, lineHeight: this.props.height + 'px'}}
                >{step.text ? step.text : index + 1}</div> }
              { step.icon &&
                <div className={`wizard-step-circle ${this.isDone(index) ? 'is-done' : 'is-not-done'}`}
                  style={{flex: this.props.height + 'px 0 0', fontSize: this.props.height/2, lineHeight: this.props.height + 'px'}}
                ><img src={step.icon}/></div>
              }
              <div className={`wizard-separator wizard-separator-right ${this.isDone(index + 1) ? 'is-done' : ''}`}
                style={{margin: this.props.height/2-4 + 'px -1px'}}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

KovWizardSteps.propTypes = {
  steps: array.isRequired,
  currentStep: number,
  height: number,
};

KovWizardSteps.defaultProps = {
  height: 60
};
